<template>
  <div class="menu" id="menu">
    <div class="menu-cover" id="menu-cover">
      <div class="bg2"></div>
      <ul>
        <li class="active">
          <router-link to="/fulfillment">Фулфилмент</router-link>
        </li>
        <li class="active">
          <router-link to="/callcenter">Колл-центр</router-link>
        </li>
        <li class="active">
          <router-link to="/consulting">Консалтинг</router-link>
        </li>
        <li class="active">
          <router-link to="/investors">Инвесторам</router-link>
        </li>
        <li class="active diff">
          <router-link to="/aboutmobile">О нас</router-link>
        </li>
        <li class="active diff">
          <router-link to="/contactmobile">Контакты</router-link>
        </li>
      </ul>
      <div class="bg glitch-img"></div>
    </div>
    <div class="menu-icon active" id="menu-icon"></div>
  </div>
</template>

<script>
import * as THREE from "three";
import $ from "jquery";
import { TimelineMax, gsap } from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";

export default {
  name: "menuIcon",
  data() {
    return {
      cube: null,
      renderer: null,
      scene: null,
      camera: null,
      sceneObjects: [],
      uniforms: {},
      mesh: null,
      meshTwo: null,
    };
  },
  mounted() {
    gsap.registerPlugin(CSSPlugin);

    var pluginName = "mgGlitch",
      defaults = {
        destroy: false,
        glitch: true,
        scale: true,
        blend: true,
        blendModeType: "hue",
        glitch1TimeMin: 600,
        glitch1TimeMax: 900,
        glitch2TimeMin: 10,
        glitch2TimeMax: 115,
        zIndexStart: 5,
      };

    // The actual plugin constructor
    function Plugin(element, options) {
      this.element = element;
      this.settings = $.extend({}, defaults, options);
      this._defaults = defaults;
      this._name = pluginName;
      this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
      // init plugin
      init: function() {
        // this.element
        // this._defaults.propertyName = get the defaults options
        // this.settings.propertyName = get options from plugin instance
        this.glitch();
      },

      // public function
      glitch: function() {
        // element glitch
        var el = this.element;

        // set options as var to use in nested functions
        // scale option : true or false
        var scale = this.settings.scale;

        // random time interval for first glitch elem : between min and max
        var glitch1TimeMin = this.settings.glitch1TimeMin;
        var glitch1TimeMax = this.settings.glitch1TimeMax;

        // random time interval for second glitch elem : between min and max
        var glitch2TimeMin = this.settings.glitch2TimeMin;
        var glitch2TimeMax = this.settings.glitch2TimeMax;

        // zIndex value for first layer
        var zIndexStart = this.settings.zIndexStart;

        // randomize number between min and max
        function getRandomInt(min, max) {
          return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        // destroy method : set true or false
        if (this.settings.destroy === true) {
          // check if created elements exists and remove them
          if (
            $(el)
              .siblings()
              .hasClass("el-front-1") ||
            $(el)
              .siblings()
              .hasClass("front-3") ||
            $(el)
              .siblings()
              .hasClass("front-2")
          ) {
            $(el)
              .siblings(".front-1, .front-2, .front-3")
              .remove();
          }
          $(".back").removeClass("back");
        } else if (this.settings.destroy === false) {
          // clone this.element insert before addclass back = static element
          var cloneEl = $(el).clone();
          cloneEl
            .insertBefore(el)
            .addClass("back")
            .css({ "z-index": zIndexStart });

          // blending elements : front-3
          if (this.settings.blend === true) {
            // clone element insert front addclass el-front-3
            var cloneEl = $(el).clone();
            cloneEl
              .insertAfter(el)
              .addClass("front-3")
              .css({
                "z-index": zIndexStart + 3,
                "mix-blend-mode": this.settings.blendModeType,
              }); // , 'mix-blend-mode': 'hard-light'
            blendElem();
          }

          // glitching element : front-1, front-2
          if (this.settings.glitch === true) {
            // clone element insert front addclass el-front-1 = first glitch element
            var cloneEl = $(el).clone();
            cloneEl
              .insertAfter(el)
              .addClass("front-2")
              .css({ "z-index": zIndexStart + 2 });

            // add class middle to elem
            $(".back")
              .next()
              .addClass("front-1")
              .css({ "z-index": zIndexStart + 1 });

            // call recursives functions with random timing apply
            glitch1(), glitch2();
          }
        }

        // first glitched element with lower timing and no scale : apply to front-1
        function glitch1() {
          var clipPos1 = getRandomInt(10, 1900);
          var clipPos2 = 9999;
          var clipPos3 = getRandomInt(10, 1300);
          var clipPos4 = 0;
          var leftValue = getRandomInt(0, 16);
          var rightValue = getRandomInt(0, 16);
          var randomTime = getRandomInt(glitch1TimeMin, glitch1TimeMax);

          // select front-1 selector : random clip, right and left values
          $(el).css({
            clip:
              "rect(" +
              clipPos1 +
              "px, " +
              clipPos2 +
              "px, " +
              clipPos3 +
              "px," +
              clipPos4 +
              "px)",
            right: rightValue,
            left: leftValue,
          });

          // set loop with random time
          setTimeout(glitch1, randomTime);
        }

        // second glitched element with higher timing + scale options : apply to front-2
        function glitch2() {
          var clipPos1 = getRandomInt(10, 1900);
          var clipPos2 = 9999;
          var clipPos3 = getRandomInt(10, 1300);
          var clipPos4 = 0;
          var leftValue = getRandomInt(0, 40);
          var rightValue = getRandomInt(0, 40);
          var randomTime = getRandomInt(glitch2TimeMin, glitch2TimeMax);

          // check if scale option is active = true or not = false
          if (scale === true) {
            // get random scale value between 0.9 and 1.1 with decimal
            var scaleValue = (Math.random() * (1.1 - 0.9) + 0.9).toFixed(2); // toFixed(n) where n = decimal
          } else if (scale === false) {
            // if false always set scale value to 1
            var scaleValue = 1;
          }

          // select front-2 selector : random clip, right, left and scale values
          $(el)
            .next()
            .css({
              clip:
                "rect(" +
                clipPos1 +
                "px, " +
                clipPos2 +
                "px, " +
                clipPos3 +
                "px," +
                clipPos4 +
                "px)",
              left: leftValue,
              right: rightValue,
              "-webkit-transform": "scale(" + scaleValue + ")",
              "-ms-transform": "scale(" + scaleValue + ")",
              transform: "scale(" + scaleValue + ")",
            });

          // set loop with random time
          setTimeout(glitch2, randomTime);
        }

        // third glitched element with higher timing + scale options + blend-mode : apply to front-3
        function blendElem() {
          var clipPos1 = getRandomInt(10, 1900);
          var clipPos2 = 9999;
          var clipPos3 = getRandomInt(10, 1300);
          var clipPos4 = 0;
          var leftValue = getRandomInt(0, 40);
          var rightValue = getRandomInt(0, 40);
          var randomTime = getRandomInt(glitch2TimeMin, glitch2TimeMax);

          // check if scale option is active = true or not = false
          if (scale === true) {
            // get random scale value between 0.9 and 1.1 with decimal
            var scaleValue = (Math.random() * (1.1 - 0.9) + 0.9).toFixed(2); // toFixed(n) where n = decimal
          } else if (scale === false) {
            // if false always set scale value to 1
            var scaleValue = 1;
          }

          // select front-3 selector : random clip, right, left and scale values
          $(el)
            .next()
            .next()
            .css({
              clip:
                "rect(" +
                clipPos1 +
                "px, " +
                clipPos2 +
                "px, " +
                clipPos3 +
                "px," +
                clipPos4 +
                "px)",
              left: leftValue,
              right: rightValue,
              "-webkit-transform": "scale(" + scaleValue + ")",
              "-ms-transform": "scale(" + scaleValue + ")",
              transform: "scale(" + scaleValue + ")",
            });

          // set loop with random time
          setTimeout(blendElem, randomTime);
        }
      },
    });

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function(options) {
      return this.each(function() {
        new Plugin(this, options);
      });
    };

    $(".bg").mgGlitch({
      destroy: false, // set 'true' to stop the plugin
      glitch: true, // set 'false' to stop glitching
      scale: true, // set 'false' to stop scaling
      blend: false, // set 'false' to stop glitch blending
      blendModeType: "none", // select blend mode type
      glitch1TimeMin: 600, // set min time for glitch 1 elem
      glitch1TimeMax: 300, // set max time for glitch 1 elem
      glitch2TimeMin: 10, // set min time for glitch 2 elem
      glitch2TimeMax: 115, // set max time for glitch 2 elem
      zIndexStart: 8, // because of absolute position, set z-index base value
    });

    var eyy = new TimelineMax();
    var yeet = false;
    $("#menu-icon").click(function() {
      if (!yeet) {
        yeet = true;
        $("#menu-cover").fadeIn();
        $("#menu-icon").css(
          "background-image",
          "url(" + require("../assets/close.svg") + ")"
        );
      } else {
        yeet = false;
        $("#menu-cover").fadeOut();
        $("#menu-icon").css(
          "background-image",
          "url(" + require("../assets/menu.svg") + ")"
        );
      }
    });

    $("#menu #menu-cover ul li").click(function() {
      $("#menu-cover").fadeOut();
      $("#menu-icon").css(
        "background-image",
        "url(" + require("../assets/menu.svg") + ")"
      );
    });

    enableScroll();

    $(".diff").click(function() {
      enableScroll();
    });

    var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

    function preventDefault(e) {
      e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    }

    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
      window.addEventListener(
        "test",
        null,
        Object.defineProperty({}, "passive", {
          get: function() {
            supportsPassive = true;
            return supportsPassive;
          },
        })
      );
    } catch (e) {
      console.log("");
    }

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent =
      "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

    function enableScroll() {
      window.removeEventListener("DOMMouseScroll", preventDefault, false);
      window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
      window.removeEventListener("touchmove", preventDefault, wheelOpt);
      window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
    }

    $(".active").mouseover(function() {
      $(".cursor").css("transform", "translate(-50%, -50%) scale(2)");
    });
    $(".active").mouseleave(function() {
      $(".cursor").css("transform", "translate(-50%, -50%) scale(1)");
    });
  },
};
</script>

<style scoped>
.glitch-img {
  pointer-events: none;
}

.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  background-image: url("../assets/img-noise-361x370.png");
  backdrop-filter: blur(2px) grayscale(100%) !important;
}

.bg2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.menu-cover {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0%;
  display: none;
  z-index: 200;
  overflow: hidden;
}

.menu-cover ul {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 15%;
  list-style: none;
  z-index: 1000;
}

.menu-cover ul li {
  line-height: 55px;
  font-size: 30px;
}

.menu-icon {
  position: fixed;
  top: 15px;
  left: 85vw;
  width: 30px;
  height: 30px;
  background-image: url("../assets/menu.svg");
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 201;
}
</style>
